// Parse the time to string
import { store } from '@/store'
import Keys from '@/constant/key'
import any = jasmine.any
import Cookies from 'js-cookie'

export const parseTime = (
  time?: object | string | number | null,
  cFormat?: string
): string | null => {
  if (time === undefined || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date: Date
  if (typeof time === 'object') {
    date = time as Date
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj: { [key: string]: number } = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

// Format and filter json data using filterKeys array
export const formatJson = (filterKeys: any, jsonData: any) =>
  jsonData.map((data: any) => filterKeys.map((key: string) => {
    if (key === 'timestamp') {
      return parseTime(data[key])
    } else {
      return data[key]
    }
  }))

// Check if an element has a class
export const hasClass = (ele: HTMLElement, className: string) => {
  return !!ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}

// Add class to element
export const addClass = (ele: HTMLElement, className: string) => {
  if (!hasClass(ele, className)) ele.className += ' ' + className
}

// Remove class from element
export const removeClass = (ele: HTMLElement, className: string) => {
  if (hasClass(ele, className)) {
    const reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// Toggle class for the selected element
export const toggleClass = (ele: HTMLElement, className: string) => {
  if (!ele || !className) {
    return
  }
  let classString = ele.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  ele.className = classString
}
export const setQueryConfig = function (queryConfig: any) {
  let _str = ''
  for (const o in queryConfig) {
    if (queryConfig[o] !== -1) {
      _str += o + '=' + queryConfig[o] + '&'
    }
  }
  _str = _str.substring(0, _str.length - 1) // 末尾是&
  return _str
}

// 获取用户信息
export const getUserInfo = function () {
  // debugger
  const paramsInfo: any = {
    projectId: 'Pj1101080259'
  }

  return paramsInfo
}


// 地址通用参赛携带
export const getComparams = function () {
  const paramsInfo: any = {
    projectId: 'Pj1101080259'
  }
}

export const formatDate = function (split: string = 'YYYYMMDD', date: any = new Date()) {
  //三目运算符
  const dates = date ? date : new Date()
  //年份
  const year: number = dates.getFullYear()
  //月份下标是0-11
  const month: any = (dates.getMonth() + 1) < 10 ? '0' + (dates.getMonth() + 1) : (dates.getMonth() + 1)
  //具体的天数
  const day: any = dates.getDate() < 10 ? '0' + dates.getDate() : dates.getDate()
  // //小时
  const Hours = dates.getHours() < 10 ? '0' + dates.getHours() : dates.getHours()
  // //分钟
  const Minutes = dates.getMinutes() < 10 ? '0' + dates.getMinutes() : dates.getMinutes()
  // //秒
  // const Seconds = dates.getSeconds() < 10 ? '0' + dates.getSeconds() : dates.getSeconds()
  //返回数据格式
  if (split === 'YYYY年MM月DD日') {
    return year + '年' + month + '月' + day + '日'
  } else if (split === 'YYYY.MM') {
    return year + '.' + month
  } else if (split === 'YYYYMM') {
    return year + '' + month
  } else if (split === 'YYYY-MM-DD') {
    return year + '-' + month + '-' + day
  } else if (split === 'YYYY.MM.DD HH:mm') {
    return year + '.' + month + "." + day + " " + Hours + ":" + Minutes
  }
  {
    return year + '' + month + '' + day
  }
}

// 把字符串 (yyyymmdd) 转换成日期格式（yyyy-mm-dd）
export const formatDateStr = function (date: any) {
  if (date) {
    return date.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3')
  } else {
    return ''
  }
}
export const getTomorrow = function (split: any = '') {
  let dates = new Date()
  dates.setTime(dates.getTime() + 24 * 60 * 60 * 1000)
  const Year: number = dates.getFullYear()
  //月份下标是0-11
  const Months: any = (dates.getMonth() + 1) < 10 ? '0' + (dates.getMonth() + 1) : (dates.getMonth() + 1)
  //具体的天数
  const day: any = dates.getDate() < 10 ? '0' + dates.getDate() : dates.getDate()
  //返回数据格式
  return Year + split + Months + split + day
}

export function getHours() {
  return new Date().getHours()
}

export function parseImgUrl(base: string, img: string) {
  if (img) {
    return `${process.env.BASE_URL}images/${base}/${img}`
  } else {
    return ''
  }
}

// 判断舒服在当前公司
export function isWithinLocation(companyConfig: any) {
  let targetLocationInfo, maxDistance
  // 是否有权限不限制距离 true-不限制，false-限制
  let remoteControl = store.state.user.remoteControl
  // let companyConfig = store.state.company.companyConfig

  if (companyConfig.sagaCare && companyConfig.sagaCareLimit) {
    maxDistance = companyConfig.sagaCareDistance
    let location = companyConfig.sagaCareCoords.split(',')
    targetLocationInfo = {
      longitude: location[0],
      latitude: location[1]
    }
  }
  maxDistance = maxDistance || 1
  let toastTip = '您好像不在公司'
}

/**
 * js 获取以前或者未来日期
 * @param year
 */
export function getAddYear(year: number = 0) {
  let time = new Date()
  time.setFullYear(time.getFullYear() + year)
  let y = time.getFullYear()
  let m = time.getMonth() + 1
  return new Date(y + '/' + m)
}



/**
 * 格式化日期 3月21日
 */
export const formatEnergyDate = function (type: any = 1) {
  //三目运算符
  let dates: any = null
  if (type == 2) {
    dates = new Date(new Date().setHours(new Date().getHours() + 1))
  } else {
    dates = new Date()
  }
  //月份下标是0-11
  const months: any = (dates.getMonth() + 1) < 10 ? '0' + (dates.getMonth() + 1) : (dates.getMonth() + 1)
  //具体的天数
  const day: any = dates.getDate() < 10 ? '0' + dates.getDate() : dates.getDate()
  const year: number = dates.getFullYear()
  const hours = dates.getHours() < 10 ? '0' + dates.getHours() : dates.getHours()
  // //分钟
  const minutes = dates.getMinutes() < 10 ? '0' + dates.getMinutes() : dates.getMinutes()
  const seconds = dates.getSeconds() < 10 ? '0' + dates.getSeconds() : dates.getSeconds()
  //返回数据格式
  return [
    year + '年' + months + '月' + day + '日',
    months + '月' + day + '日',
    hours + ':' + minutes + ":" + seconds
  ]
}

// 获取当前时间是周几
export const getWeek = function () {
  let week:any = new Date().getDay();  
  let str:any=''
  if (week == 0) {  
          str = "星期日";  
  } else if (week == 1) {  
          str = "星期一";  
  } else if (week == 2) {  
          str = "星期二";  
  } else if (week == 3) {  
          str = "星期三";  
  } else if (week == 4) {  
          str = "星期四";  
  } else if (week == 5) {  
          str = "星期五";  
  } else if (week == 6) {  
          str = "星期六";  
  }  
}





